(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gowara-home-sections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;

    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('[data-gowara-reveal]').forEach((element) => {
      if (element.dataset.gowaraRevealReady) return;
      element.dataset.gowaraRevealReady = 'true';
      element.classList.add('gowara-home-builder__reveal');
      revealObserver.observe(element);
    });

    document.querySelectorAll('[data-gowara-review-slider]').forEach((slider) => {
      if (slider.dataset.gowaraSliderReady) return;
      slider.dataset.gowaraSliderReady = 'true';

      let sliderTimer;
      const startSlider = () => {
        window.clearInterval(sliderTimer);
        sliderTimer = window.setInterval(() => {
          const card = slider.querySelector('.gowara-home-builder__review');
          if (!card) return;
          const gap = Number.parseFloat(window.getComputedStyle(slider).columnGap || '0');
          const nextLeft = slider.scrollLeft + card.offsetWidth + gap;
          const atEnd = nextLeft + slider.clientWidth >= slider.scrollWidth - 8;
          slider.scrollTo({ left: atEnd ? 0 : nextLeft, behavior: 'smooth' });
        }, 3800);
      };

      slider.addEventListener('pointerenter', () => window.clearInterval(sliderTimer));
      slider.addEventListener('pointerleave', startSlider);
      slider.addEventListener('focusin', () => window.clearInterval(sliderTimer));
      slider.addEventListener('focusout', startSlider);
      startSlider();
    });
  })();

  (() => {
    const fallback = document.querySelector('[data-gowara-home-chat-fallback]');
    if (!fallback) return;

    const boot = () => {
      if (document.querySelector('[data-gowara-customer-chat]')) {
        fallback.remove();
        return;
      }

      const panel = document.getElementById('GowaraHomeCustomerChatPanel');
      const openButtons = document.querySelectorAll('[data-gowara-home-chat-open]');
      const closeButtons = document.querySelectorAll('[data-gowara-home-chat-close]');

      const setChatOpen = (isOpen) => {
        fallback.setAttribute('data-open', isOpen ? 'true' : 'false');
        openButtons.forEach((button) => {
          button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
        if (isOpen && panel) panel.focus({ preventScroll: true });
      };

      openButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          setChatOpen(true);
        });
      });

      closeButtons.forEach((button) => {
        button.addEventListener('click', () => setChatOpen(false));
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') setChatOpen(false);
      });

      if (window.location.search.includes('contact_posted=true') || window.location.hash === '#GowaraHomeCustomerChat') {
        setChatOpen(true);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gowara-recipes-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const recipeLinkMap = {
      '/products/jaggery-nuts': '/products/jaggery-with-nuts',
      '/products/premium-vermicelli': '/products/vermicelli-packet',
      '/products/hareer-murabba-a-natural-boost-for-wellness-%F0%9F%8C%BF-copy': '/products/tummah-murabba',
      '/products/apple-murabba-a-sweet-and-healthy-treat-%F0%9F%8D%8E-copy': '/products/bans-murabba',
      '/products/olive-achar-authentic-amp-flavorful-pickle-copy-1': '/products/amla-murabba',
      '/products/gajar-murabba-sweet-nutritious-and-delightful-copy': '/products/hareer-murabba',
      '/products/bans-murabba-the-perfect-blend-of-health-and-taste-%F0%9F%8C%B1-copy': '/products/gajar-murabba',
      '/products/indian-gooseberry-amla-murabba-a-tangy-and-nutrient-rich-delight-copy': '/products/apple-murabba',
      '/products/amla-achar-tangy-amp-nutritious-pickle-copy': '/products/olive-achar',
      '/products/amla-achar-tangy-amp-nutritious-pickle': '/products/amla-achar',
      '/products/mango-pickle-tangy-spicy-and-authentic-copy': '/products/mix-pickle',
      '/products/olive-achar-authentic-amp-flavorful-pickle-copy': '/products/lasora-achar',
      '/products/garlic-pickle-bold-flavorful-and-irresistible-copy': '/products/mango-pickle',
      '/products/lasora-achar-indian-olive-pickle-copy': '/products/garlic-pickle',
      '/products/mix-pickle-a-burst-of-flavors-in-every-bite-copy': '/products/moringa-pickles'
    };

    const rewriteRecipeLinks = () => {
      document.querySelectorAll('.gowara-recipes-hub a[href]').forEach((link) => {
        try {
          const url = new URL(link.getAttribute('href'), window.location.origin);
          const cleanPath = recipeLinkMap[url.pathname];
          if (cleanPath) link.setAttribute('href', cleanPath);
        } catch (error) {
          return;
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', rewriteRecipeLinks, { once: true });
    } else {
      rewriteRecipeLinks();
    }
    document.addEventListener('shopify:section:load', rewriteRecipeLinks);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gowara-sattu-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver((entries, revealObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('.gowara-sattu-page [data-gowara-reveal]').forEach((element) => {
      element.classList.add('gowara-sattu-page__reveal');
      observer.observe(element);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
